import { useEffect } from 'react';

interface IWakeLockSentinel {
  release(): Promise<void>;
}

/**
 * Mantém a tela acesa enquanto o telão está aberto. O navegador solta o lock
 * quando a aba fica oculta, então ele é pedido de novo ao voltar a ficar
 * visível. Sem suporte (ou sem permissão), não faz nada.
 */
export default function useWakeLock(): void {
  useEffect(() => {
    const wakeLock = (
      navigator as Navigator & {
        wakeLock?: { request(type: 'screen'): Promise<IWakeLockSentinel> };
      }
    ).wakeLock;

    if (!wakeLock) return undefined;

    let sentinel: IWakeLockSentinel | null = null;
    let active = true;

    const request = async () => {
      if (!active || document.visibilityState !== 'visible') return;
      try {
        sentinel = await wakeLock.request('screen');
      } catch {
        // Sem permissão (ex.: aba em segundo plano): tenta de novo ao voltar.
      }
    };

    request();
    document.addEventListener('visibilitychange', request);

    return () => {
      active = false;
      document.removeEventListener('visibilitychange', request);
      sentinel?.release().catch(() => undefined);
    };
  }, []);
}
